import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';

import { colors, radii } from '../../../core/theme/tokens';
import { useChartWidth } from './useChartWidth';

type ChartFrameProps = PropsWithChildren<{
  height: number;
  style?: StyleProp<ViewStyle>;
  render: (width: number) => React.ReactNode;
}>;

export function ChartFrame({ height, style, render }: ChartFrameProps) {
  const { width, onLayout } = useChartWidth();

  return (
    <View style={[styles.frame, { height }, style]} onLayout={onLayout}>
      {width > 0 ? render(width) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  frame: {
    width: '100%',
    backgroundColor: colors.surfaceElevated,
    borderRadius: radii.md,
    borderWidth: 1,
    borderColor: colors.border,
    overflow: 'hidden',
  },
});
